import PublicationCard from "./PublicationCard";

export default class RealisationFilter {
  constructor(options) {
    this.$el = options.$el;
    this.ppp = 8; // Post per page
    this.pageNumber = 2;
    this.loadMoreEnable = true;
    this.$loadMore = this.$el.querySelector(".js-load-more");
    this.$container = document.querySelector(".js-realisation-grid");
    this._appendElement = this.appendElement.bind(this);
    this._load_posts = this.load_posts.bind(this);

    this.init();

    if (
      this.$container &&
      this.$container.getAttribute("data-lastpage") == "true"
    ) {
      this.$loadMore.classList.add("hidden");
      this.loadMoreEnable = false;
    }
  }

  getUrlVars() {
    let vars = {};
    let parts = window.location.href.replace(
      /[?&]+([^=&]+)=([^&]*)/gi,
      function (m, key, value) {
        vars[key] = value;
      }
    );
    return vars;
  }

  getUrlParam(parameter, defaultvalue) {
    let urlparameter = defaultvalue;

    if (window.location.href.indexOf(parameter) > -1) {
      urlparameter = this.getUrlVars()[parameter];
    }
    return urlparameter;
  }

  load_posts() {
    if (!this.loadMoreEnable) return;
    this.loadMoreEnable = false;

    let type = this.getUrlParam("type", "all");

    let params =
      "action=more_realisation_ajax" +
      "&type=" +
      type +
      "&pageNumber=" +
      this.pageNumber +
      "&ppp=" +
      this.ppp +
      "&die=1";

    const url = "/wp-admin/admin-ajax.php";
    const http = new XMLHttpRequest();

    http.open("GET", url + "?" + params, true);
    let that = this;

    http.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        that.appendElement(this.response);
        that.pageNumber++;
        that.loadMoreEnable = true;
      } else {
        console.error("error", this.response);
        that.loadMoreEnable = false;
      }
    };
    http.onerror = function (error) {
      console.log("error", error);
    };
    http.send(null);
  }

  setEvent() {
    this.$loadMore.addEventListener("click", this._load_posts);
  }

  getNodes(str) {
    return document.createRange().createContextualFragment(str);
  }

  init() {
    this.setEvent();
  }

  appendElement(str) {
    let nodes = this.getNodes(str);

    console.log(nodes);

    if (nodes.firstChild.getAttribute("data-lastpage") == "true") {
      this.$loadMore.classList.add("hidden");
      this.loadMoreEnable = false;
    }

    let items = nodes.querySelectorAll(".publicationCard");

    [].slice.call(items).forEach((element) => {
      this.$container.appendChild(element);

      const button = element.querySelector(".btnSecondary");

      element.addEventListener("mouseenter", () => {
        button.classList.toggle("active");
      });

      element.addEventListener("mouseleave", () => {
        button.classList.toggle("active");
      });
    });
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/RealisationFilter.js